const COOKIE_CONSENT_ENDPOINT = '/cookie_consent';

const acceptCookieConsent = (banner) => {
  const csrfToken = document.querySelector("meta[name='csrf-token']")?.getAttribute('content');

  fetch(COOKIE_CONSENT_ENDPOINT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'X-CSRF-Token': csrfToken
    },
    credentials: 'same-origin'
  }).finally(() => {
    banner.classList.remove('show');
    banner.classList.add('d-none');
  });
};

const setupCookieConsent = () => {
  const banner = document.querySelector('.js-cookie-consent');
  if (!banner) return;

  const acceptButton = banner.querySelector('.js-cookie-consent-accept');
  if (!acceptButton) return;

  acceptButton.addEventListener('click', () => {
    acceptCookieConsent(banner);
  });
};

document.addEventListener('DOMContentLoaded', setupCookieConsent);
